const cust_id = __st.cid;

const server_url="https://nodeapi.luarbeauty.in"
jQuery(document).ready(function(){

    if (cust_id) {
        setTimeout(function () {
            fetchCustomerPoints(cust_id);
        }, 2000)
    }
})

async function applyAndFetchDiscount(discountCode) {
    try {
        const response = await fetch(`/discount/${discountCode}`, { method: "GET" });
        if (!response.ok) throw new Error("Failed to apply discount");
        updateCartDrawer();
        updatemainCart()

    } catch (error) {
        removeDiscount();
        // console.error("Error applying discount code:", error);
    }
}

async function removeDiscount() {
    try {
        const response = await fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ attributes: { "discount_code": "" } }) // Remove discount
        });

        if (!response.ok) throw new Error("Failed to remove discount");

        updateCartDrawer();
        updatemainCart();
    } catch (error) {
        console.error("Error removing discount:", error);
    }
}

function updateCartDrawer() {
    $.ajax({
        url: "/?section_id=cart-drawer",
        type: "GET",
        dataType: "html",
        success: function (carthtml) {
            $("cart-drawer").html($(carthtml).find("cart-drawer").html());
            fetchCustomerPoints(cust_id);
        },
    });
}
function updatemainCart() {
    $.ajax({
        url: "cart",
        type: "GET",
        dataType: "html",
        success: function (carthtml) {
            $(".cart__footer-wrapper").html($(carthtml).find(".cart__footer-wrapper").html());
            fetchCustomerPoints(cust_id);
        },
    });
}

function fetchCustomerPoints(customerId) {
    let sessionStorageKey = `customerPoints_${customerId}`;
    let cachedData = "";

    if (cachedData) {
        processPointsData(JSON.parse(cachedData));
    } else {
        var xhr = new XMLHttpRequest();
        xhr.withCredentials = true;

        xhr.addEventListener("readystatechange", function () {
            if (this.readyState === 4) {
                let point_data = JSON.parse(this.responseText);
                processPointsData(point_data);
            }
        });

        xhr.open("GET", `${server_url}/get-discount?customerId=${customerId}`);
        xhr.send();
    }
}
function setSessionStorage(pointData) {
    let sessionStorageKey = `customerPoints_${cust_id}`;
      // Store data in sessionStorage
      sessionStorage.setItem(sessionStorageKey, JSON.stringify(pointData));
}

function processPointsData(point_data) {
    setSessionStorage(point_data);
    let pointdata = point_data.currentPoints;
    let pointstitle = point_data.pointsTitle;
    updateRewardPointsUI(pointdata, pointstitle);
    allRewardsPointsCheck(point_data);
    // in Account page show points
    jQuery(".customer__reward_data .rewardPoints").text(pointdata);
    jQuery.get("/cart.json", function(data) {
        if (data.item_count === 0) {
            if (jQuery(".remove_points").length > 0) {
                let id = jQuery(".remove_points").attr('data-id');
                let data = { discountId: id };
                removePoints(data);
            } else {
                
                updateCartPointsUI(pointdata, "");
            }
        }
        else {
            updateCartPointsUI(pointdata, "");
        }
    });
                
}


function waitForElement(selector, callback) {
    const element = document.querySelector(selector);
    if (element) {
        callback();
    } else {
        setTimeout(() => waitForElement(selector, callback), 100);
    }
}
function updateCartPointsUI(points, disId) {
    let point = points
    let checkDiscountActive = localStorage.getItem("discountData") ? JSON.parse(localStorage.getItem("discountData")) : "";
    let html = checkDiscountActive.applyDiscount
        ? `<div class="card-body shopping_rewards_points"><span>0 REWARD POINTS</span><span class="shopping_cart_rewards_pointss_rs bkTotalPoint" data-points="${point}">(INR. 0)</span></div>
        <div class="shopping_cart_rewards_btn_apply"><button class="button remove_points" data-id="${checkDiscountActive.disid}">REMOVE</button></div>`
        : `<div class="card-body shopping_rewards_points"><span>${point} REWARD POINTS</span><span class="shopping_cart_rewards_pointss_rs bkTotalPoint" data-points="${point}">(INR. ${point/100})</span></div>
        <div class="shopping_cart_rewards_btn_apply">${point == 0?`` :`<button class="button applyPoints">APPLY</button></div>`}`;
    $(".bkpoints").html(html);
}
function updateRewardPointsUI(points, pointstitle) {
    let point = points    
    let html = `<h3 class="tire_title">${pointstitle}</h3>
          <h4 class="my_points">${point}</h4><span class="text-sm text-gray-500 rewards_available_text">AVAILABLE</span>`;
    $(".rewards_available").html(html);
    $(".rewards_available .ct_loader").hide();
}

$(document).on("click", "#discount-form", function (e) {
    e.preventDefault();
    let discountCode = $("#discount-code").val();
    applyAndFetchDiscount(discountCode);
});

$(document).on("click", ".applyPoints", function () {
    $('.drawer__inner .ct-form-loader-main.ct-loader-container').css("display", "flex");
    let points = parseFloat($(".bkpoints .bkTotalPoint").attr("data-points"));
    let cart_total_amount=jQuery(".bkCartTotal").attr("data-cart-total");
    let data = {
        amount: cart_total_amount,
        customerId: cust_id,
        points: points,
    };
    $.post(`${server_url}/create-discount`, data, function (result) {
        $("#discount-code").val(result.discountCode);
        let localData = {
            "applyDiscount": "true",
            "disid": result.discountId
        };
        localStorage.setItem("discountData", JSON.stringify(localData));
        // localStorage.setItem("applyDiscount", "true");
        // localStorage.setItem("disid", result.points.disId);
        $("#discount-form").trigger("click");
        let disId = result.discountId
       // updateCartPointsUI(result.points, disId);        
        // $('.ct-form-loader-main.ct-loader-container').css("display", "none");
    }).fail(function (error) {
        console.error("Error applying points:", error);
    });
});
$(document).on("click", ".remove_points", function () {
  $('.drawer__inner .ct-form-loader-main.ct-loader-container').css("display", "flex");
    let id = jQuery(this).attr('data-id');

    let data = {
        discountId: id
    };
    removePoints(data);
});

jQuery(document).on("click", ".save-btn", function (e) {
  e.preventDefault();
    let selected_month = jQuery("#birthdayForm select option:selected").val();
    let selected_day = jQuery("#birthdayForm select[name='day'] option:selected").val();
    let selected_year = jQuery("#birthdayForm select[name='year'] option:selected").val();
  // Check if any field is empty
    if (!selected_day || !selected_month || !selected_year) {
        alert("Please fill in all birthdate fields.");
        return;
    }
    let birthdate = selected_day + "/" + selected_month + "/" + selected_year;
    let customerId = cust_id; 

    jQuery.ajax({
        url: `${server_url}/api/create/birthdate`,
        type: "POST",
        data: JSON.stringify({
            customerId: customerId,
            birthdate: birthdate
        }),
        contentType: "application/json",
        success: function (response) {
            if (response.success) { 
                jQuery("#birthdayModal").hide();
                fetchCustomerPoints(cust_id)
            }
            console.log("Success:", response);
            
        },
        error: function (error) {
            console.log("Error:", error);
        }
    });
});

jQuery(document).on("click", ".ct-write-review-popup-submit-btn", function () {
    let reviewproductSelectId = jQuery("#ct-product option:selected").attr("data-product-id");
    let reviewName = jQuery(".review_name").val().trim();
    let reviewTitle = jQuery(".review_title").val().trim();
    let reviewPoint = jQuery(".review_star").attr("data-star-review");
    let reviewEmail = jQuery(".review_email").val().trim();
    let reviewBody = jQuery(".review_body").val().trim();

    // Validation
    if (!reviewproductSelectId) {
        alert("Please select a product.");
        return;
    }
    if (!reviewName) {
        alert("Please enter your name.");
        return;
    }
    if (!reviewEmail || !validateEmail(reviewEmail)) {
        alert("Please enter a valid email address.");
        return;
    }
    if (!reviewPoint) {
        alert("Please provide a rating.");
        return;
    }
  if (!reviewTitle) {
        alert("Please enter your review title.");
        return;
    }
    if (!reviewBody) {
        alert("Please enter your review.");
        return;
    }

    let reviewData = {
        "name": reviewName,
        "email": reviewEmail,
        "rating": reviewPoint,
        "title": reviewTitle,
        "body": reviewBody,
        "productId": reviewproductSelectId
    };

    jQuery.ajax({
        url: `${server_url}/submit-review?customerId=${cust_id}`,
        type: "POST",
        data: JSON.stringify(reviewData),
        contentType: "application/json",
        success: function (response) {
            $('.ct-review-submitted-main').show();
            $('.ct-write-review-popup-main').hide();
            processPointsData(response.points);
           // Reload the page after 2 seconds
            setTimeout(function () {
                location.reload();
            }, 2000);
        },
        error: function (error) {
            console.log("Error:", error);
        }
    });
});
jQuery(document).on("click", "#instafollow", function () {  
    

    jQuery.ajax({
        url: `${server_url}/api/insta/instapoints?customerId=${cust_id}`,
        type: "POST",
        contentType: "application/json",
        success: function (response) {
            if (response.success) { 
                window.open('https://www.instagram.com/luarbeauty.in/', '_blank');
                processPointsData(response.points);

            }
        },
        error: function (error) {
            console.log("Error:", error);
        }
    });
});

jQuery(document).on("click",".ctCart",function(){
  let cartCount=jQuery(".cart-count-bubble span:first").text();
  if(cartCount > 0)
  {
    jQuery(".header__icons #cart-icon-bubble .svg-wrapper").click();
  }
  else
  {
    window.location.href="https://luarbeauty.in/collections/shop-all"    
  }
})
// Email validation function
function validateEmail(email) {
    let emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
}


  $(document).on("click", "#ct_write_review", function () {
      $('.ct-write-review-popup-main').show();
  });
  $(document).on("click", ".ct-write-review-popup-close", function () {
      $('.ct-write-review-popup-main').hide();
  });
  $(document).on("click", ".ct-review-submitted-close", function () {
      $('.ct-review-submitted-main').hide();
  });
    $(".ct-write-review-star").click(function () {
        let index = $(this).index() + 1;
        $(".ct-write-review-star").each(function (i) {
            if (i < index) {
                $(this).find("path").attr("fill", "#41333b"); // Gold color for selected stars
            } else {
                $(this).find("path").attr("fill", "#D7CED6"); // Default color for unselected stars
            }
        });
        $(".ct-write-review-popup-star").attr("data-star-review", index);
    });


async function allRewardsPointsCheck(points)
  {
    
    if(points.birthdatePoints)
    {
      jQuery("#openModalBtn").closest(".earn-point-block").find(".login_hover_content").html(`<span><p><strong>2000</strong><br>points earned</p></span><a href="javascript:void(0)" id="openModalBtn" class="ct-link">Claimed</a>`);
      
      // jQuery("#openModalBtn").replaceWith(`<a href="javascript:void(0)" id="openModalBtn" class="ct-link">Claimed</a>`);
      jQuery("#openModalBtn").closest(".block-item").addClass("claimed")
    }
    if(points.reviewPoints)
    {
      await checkProductReviews();
      
       jQuery("#ct_write_review").closest(".earn-point-block").html(`<div class="hover-content login_hover_content"><span><p><strong>8000</strong><br>points earned</p></span><a href="javascript:void(0)" id="ct_write_review" class="ct-link">Claimed</a></div>`);
        //   let countOptions= 
        const visibleOptionCount = jQuery('#ct-product option').filter(function () {
          return jQuery(this).css('display') !== 'none';
        }).length;

      if(visibleOptionCount >= 1)
      {
        jQuery("#ct_write_review").closest(".earn-point-block").find(".login_hover_content").after(`<div class="write_review"> <span><p><strong>Get 8000 points</strong></p><p>when you review our products<br><br></p></span> <a id="ct_write_review" href="#" class="ct-link"> Share Your Review Now </a></div>`);
        // <div class="hover-content login_hover_content"></div>
      }
      
      
       // jQuery("#ct_write_review").replaceWith(`<a href="javascript:void(0)" id="ct_write_review" class="ct-link">Claimed</a>`)
       jQuery("#ct_write_review").closest(".block-item").addClass("claimed")
    }
     if(points.instagramPoints)
    {
      jQuery("#instafollow").closest(".earn-point-block").find(".login_hover_content").html(`<span><p><strong>3000</strong><br>points earned</p></span><a href="javascript:void(0)" id="instafollow" class="ct-link">Claimed</a>`);
      
      // jQuery("#instafollow").replaceWith(`<a href="javascript:void(0)" id="instafollow" class="ct-link">Claimed</a>`)
      jQuery("#instafollow").closest(".block-item").addClass("claimed")
    }
    if(points.customerPoints)
    {
      jQuery("#accountcreate").closest(".earn-point-block").find(".login_hover_content").html(`<span><p><strong>5000</strong><br>points earned</p></span><a href="javascript:void(0)" id="accountcreate" class="ct-link">Claimed</a>`);
    
      //jQuery("#accountcreate").replaceWith(`<a href="javascript:void(0)" id="accountcreate" class="ct-link">Claimed</a>`)
      jQuery("#accountcreate").closest(".block-item").addClass("claimed")
    }
    if(points.shadePoints)
    {
      jQuery("#shadematch").closest(".earn-point-block").find(".login_hover_content").html(`<span><p><strong>2000</strong><br>points earned</p></span><a href="javascript:void(0)" id="shadematch" class="ct-link">Claimed</a>`);
      //jQuery("#shadematch").replaceWith(`<a href="javascript:void(0)" id="shadematch" class="ct-link">Claimed</a>`)
      jQuery("#shadematch").closest(".block-item").addClass("claimed")
    }
    else
    {
      jQuery("#shadematch").replaceWith(`<a class="ct-link" href='https://luar-beauty.myshopify.com/pages/shade-finder'>Select Your Shade </a>`)      
    }
    $('.earn-point-block .ct-loader-container').hide();
  }
function checkProductReviews(){  
   $.ajax({
          url: `https://nodeapi.luarbeauty.in/get-reviewed-products?customerId=${cust_id}`,
          type: "GET",
           dataType: "json", 
          success: function (pId) {
            if(pId.reviewedProductIds != "")
            {
              console.log("=====")
              jQuery(pId['reviewedProductIds']).each(function(e,p){
                jQuery(`.pid_${p}`).hide();
                
              })
            }
              console.log("PID", pId);
          },
      });
}
function removePoints(data){ 
    $.post(`${server_url}/revert-points`, data, function (result) {
        if (result.success) {
            localStorage.removeItem("discountData");
            removeDiscount()
        }
    }).fail(function (error) {
        console.error("Error applying points:", error);
    });
}
